import { Settings } from "@material-ui/icons";
import { context } from "msw";
import { ErrorCode, ResponceDataType } from "../../../../ErrorCode";
import { StudySettingModel } from "../StudySetting/StudySetting";
import { NAME_DEV_SET, GetNameDevSetList } from '../../../../function/NameDevSetModel';
import i18next from 'i18next';

/**
 * コナンエア管理画面(編集)項目
 */
export type CONNAIR_SET = {
  /**コナンエアID */
  CNA_ID: string;
  /** 機器INDEX*/
  DEV_INDEX: number;
  /**項目名称No. */
  ITM_NAME_NO: number;
  PLC_NO: number;

  devName: string;
  /**取付箇所 */
  itemName: string;
  /** リスト編集フラグ */
  isEdit: boolean;
  /** 時刻設定 */
  logStart: string;
}

export type ConanAirUpdateType = {
  /**コナンエアID */
  CNA_ID: string;
  /** 機器INDEX*/
  DEV_INDEX: number;
  /**項目名称No. */
  ITM_NAME_NO: number;

  devName: string;
}
/**
 * COL_SETの時刻設定編集項目
 */
export type ColSetLogModel = {
  PlcNo?: number;
  LogStart: string;
}

export type ConanairManagementModel = {
  ConanairSetList: CONNAIR_SET[],
  ColSetLogList: ColSetLogModel[],
  ResponceDataModel?: ResponceDataType
}

export type ConanAirSetModel = {
  ConanairSet: CONNAIR_SET,
  ColSetLog: ColSetLogModel
}

/**
 * APIレスポンスコード
 */
export const ApiResponseCode = {
  DEFAULT: 200,
  SUCCESS: 204,         //新規登録要求待ちレコード追加
  BAD_REQUEST: 400,     //パラメータ異常
  NOT_ACCEPTABLE: 406,  //状態チェック
  DEVINDEX_IOT_REGISTERED: 412, //TMBEE-BOX管理画面側で、選択した機器番号の使用がある
  UPDATE_FAILURE: 500,  //更新失敗
  SERVICE_UNAVAILABLE: 503,  //ネットワーク接続失敗
} as const;
type ApiResponseCode = typeof ApiResponseCode[keyof typeof ApiResponseCode];

/**
 *
 * @returns デフォルトデータ作成
 */
export const CreateConanairManagementModel = (): ConanairManagementModel => {
  let ret: ConanairManagementModel = {
    ConanairSetList: [],
    ColSetLogList: []
  };
  return ret;
}

/**
 * コナンエア管理データ取得
 * @returns
 */
export const GetConanairManagement = (): Promise<ConanairManagementModel> => {
  return new Promise((resolve, reject) => {
    fetch("api/ConanAirManagement/")
      .then((res) => {
        console.debug(["res", res]);
        if (!res.ok) {
          console.error(res);
          let message = `データが見つかりませんでした status:${res.status}`;
          console.debug(["message", message]);
          throw new Error(message);
        }
        else {
          console.debug(["res.json", res]);
          return res.json();
        }
      })
      .then((result: ConanairManagementModel) => {
        console.debug(["GetConanairManagement - ok ret ", result]);
        if (result != null) {
          if (result.ConanairSetList.length !== 0) {
            result.ConanairSetList.map((row, index) => {
              row.isEdit = false;
            });
            console.debug(["--result.ConanairSetList--", result.ConanairSetList]);
          }
          console.debug(["GetConanairManagement - ok ret ", result]);
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      })
      .catch((error) => {
        console.debug(["error", error]);
        console.error(error.status);
        console.error(error);
        reject(error);
      })
  })
};

/**
 * Conanair 新規登録
 * @param data
 * @returns
 */
export const InsertConanAirManagement = (data: ConanAirSetModel): Promise<number> => {
  console.debug(['InsertConanAirManagement', data]);

  return new Promise((resolve, reject) => {
    fetch('api/ConanAirManagement', {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(res => {
        console.debug(['res', res]);
        resolve(res.status)
      })
      .catch(reason => {
        console.debug(['reason', reason]);
        reject(reason)
      });
  });
}

/**
 * Conanair 削除
 * @param conanairId
 * @returns
 */
export const DeleteConanAirManagement = (conanairId: string): Promise<number> => {
  console.debug(['deleteConanairSet', conanairId]);

  return new Promise((resolve, reject) => {
    fetch('api/ConanAirManagement', {
      method: 'delete',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(conanairId),
    })
      .then(res => {
        console.debug(['res', res]);
        resolve(res.status)
      })
      .catch(reason => {
        console.debug(['reason', reason]);
        reject(reason)
      });
  });
}

/**
 * コナンエアデータ更新
 * @param settings
 * @returns
 */
export const PutConanairManagement = (settings: ConanairManagementModel): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    settings.ConanairSetList = settings.ConanairSetList.filter((r) => r.isEdit == true);
    console.debug(["PutConanairManagement - updateSetting", settings]);
    fetch("api/ConanAirManagement/", {
      method: "put",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(settings)
    }).then((res) => {
      if (!res.ok) {
        let message = `データが見つかりませんでした status:${res.status}`;
        reject(message);
      }
      return res.json();
    }).then((result: ResponceDataType) => {
      console.debug(["PutConanairManagement - result ", result])
      resolve(result);
    },
      (error) => {
        console.error(error);
        reject(error);
      })
  });
}

/**
 * 編集チェック
 */
export const CheckConanairManagementFlg = (targetModel: CONNAIR_SET[]): boolean => {
  //console.debug(["★test1",targetModel])
  if (targetModel == null || targetModel.length == 0) {
    return false;
  }
  if ((targetModel.findIndex((r) => r.isEdit == true) === -1)) {
    //console.debug(["★test2",targetModel]);

    return false;
  }
  //console.debug(["★test3",targetModel])
  return true;
}

/**
 * 入力値チェック
 * @param setting
 */
export const CheckInputData = (setting: CONNAIR_SET[], nameDev: NAME_DEV_SET[], translation: any): string[] => {
  let message: string[] = [];
  //DEVINDEX,ITM_NAME_NOの重複チェック
  let cRow = setting.filter((r) => r.DEV_INDEX > 0);

  cRow.forEach((r, index) => {
    let f = cRow.findIndex((rr) => rr.DEV_INDEX === r.DEV_INDEX && rr.ITM_NAME_NO === r.ITM_NAME_NO);
    if (f !== index) {
      let deveItem = nameDev.find((res) => res.DEV_INDEX === r.DEV_INDEX);
      console.debug(["CheckInputData - error ", r]);
      message.push(`${deveItem?.DEV_NAME} ` + i18next.t('ConanairManagement.重複エラー', ':機器番号,取付箇所 重複エラー'));
    }
  });
  return message;
};
